import React from 'react';
import { UseFormRegister, UseFormWatch, UseFormSetValue } from 'react-hook-form';
import { RadioInput } from 'components/form';
import { QUESTION_CARD, QUESTION_TITLE, QUESTION_SUBTITLE, QUESTION_OPTIONS, QUESTION_ERROR } from '../card-classes';

interface Option {
  label: string;
  value: string;
}

interface QuestionCheckboxWithRatingProps {
  register: UseFormRegister<any>;
  watch: UseFormWatch<any>;
  setValue: UseFormSetValue<any>;
  errors: any;
  name: string;
  ratingName: string;
  options: Option[];
  questionText: string;
  questionNumber: number;
  labelText: string;
  containerClassName?: string;
  titleClassName?: string;
  subtitleClassName?: string;
  radioContainerClassName?: string;
  errorMessageClassName?: string;
}

export const QuestionCheckboxWithRating: React.FC<QuestionCheckboxWithRatingProps> = ({
  register,
  watch,
  setValue,
  errors,
  name,
  ratingName,
  options,
  questionText,
  questionNumber,
  labelText,
  containerClassName,
  titleClassName,
  subtitleClassName,
  radioContainerClassName,
  errorMessageClassName,
}) => {
  const selectedOptions = watch(name) || [];
  const selectedValues = Array.isArray(selectedOptions) ? selectedOptions : [selectedOptions].filter(Boolean);

  return (
    <div className={`${QUESTION_CARD} ${containerClassName || ''}`}>
      <h3 className={`${QUESTION_TITLE} ${titleClassName || ''}`}>
        {questionNumber}. {questionText}
      </h3>
      <p className={`${QUESTION_SUBTITLE} ${subtitleClassName || ''}`}>
        {labelText}
      </p>
      <RadioInput
        register={register}
        name={name}
        options={options}
        type="checkbox"
        parentClassName={`${QUESTION_OPTIONS} ${radioContainerClassName || ''}`}
        validatorMessage={errors?.[name]?.message}
        disabled={selectedValues.length >= 1}
        checkValue={selectedValues}
        value={selectedOptions[0]}
        rating={{
          value: watch(ratingName) ?? 0,
          onChange: (x: number) => setValue(ratingName, x),
          count: 5,
          startAt: 1,
        }}
      />
      {errors[ratingName] && (
        <small className={`${QUESTION_ERROR} ${errorMessageClassName || ''}`}>
          {errors?.[ratingName]?.message}
        </small>
      )}
    </div>
  );
};